// Mixing jQuery and Node.js code in the same file? Yes please!

/*$(function(){

    $('.logField').append('<br>Comando recibido: <span>' + 'Hola comando' + '</span>');    

});*/

import { getDaysBetweenDates } from '../utils/Utils'
import { requestPostSail } from '../utils/requester'

//var URL_USER_SERVICES = "https://app.flipwit.com/sails/";
var URL_USER_SERVICES = process.env.REACT_APP_URL_SERVICES + "user";


let userService = {};
let currentUser = {};

function UserService() {
  userService.init();
  return userService;
}

userService.init = function() {
}

userService.signOut = function() {
  currentUser = {};
}

userService.getCurrentUser = function() {
  return currentUser;
}

userService.loginOnBackend = (firebaseAuthUser, auth_uid) => {

  console.log('Login on back',firebaseAuthUser)

  return new Promise((resolve, reject) => {

    var callbackLogin = function(user) {
      if(user && (user.fname || user.lname)) {
        user.displayName = (user.fname?user.fname:'') + (user.lname?' ' + user.lname:'');
        user.uid = firebaseAuthUser.uid;
        user.auth_uid = auth_uid;
        currentUser = user;
        
        var expiration = new Date(user.mem_expire).getTime();
        var today = new Date().getTime();
        
        console.log('User',user);

        // if the current user is under a valid period time...
        if(today <= expiration || user.isInstitutionalUser) {
          user.daysLeft = getDaysBetweenDates(today, expiration);
        } else {
          user.active = 'n';
        }

        resolve(user);
      } else {
        // user is an error
        if(typeof Raven !== 'undefined') {
          //TODO Raven.captureException(user);
        }
        reject(user);
      }
    };

    requestPostSail(URL_USER_SERVICES + '/loginFromFlipwitApp', firebaseAuthUser, callbackLogin);
    
  });
  
}


export let userHandler = new UserService();


// WEBPACK FOOTER //
// ./src/containers/platforms/UserHandler.js